import { create } from 'zustand';

interface UnreadMessagesState {
  totalNoLeidos: number;
  mensajesNoLeidosPorPedido: Record<string, number>;

  // Actions
  setTotalNoLeidos: (count: number) => void;
  setNoLeidosPorPedido: (data: Record<string, number>) => void;
  incrementarNoLeidos: (pedidoId: string) => void;
  limpiarNoLeidos: (pedidoId: string) => void;
  reset: () => void;
}

export const useUnreadMessagesStore = create<UnreadMessagesState>((set, get) => ({
  totalNoLeidos: 0,
  mensajesNoLeidosPorPedido: {},

  setTotalNoLeidos: (count: number) => {
    set({ totalNoLeidos: count });
  },

  setNoLeidosPorPedido: (data: Record<string, number>) => {
    set({ mensajesNoLeidosPorPedido: data });
    // Recalcular total
    const total = Object.values(data).reduce((sum, count) => sum + count, 0);
    set({ totalNoLeidos: total });
  },

  incrementarNoLeidos: (pedidoId: string) => {
    const state = get();
    const prevCount = state.mensajesNoLeidosPorPedido[pedidoId] || 0;
    const newData = {
      ...state.mensajesNoLeidosPorPedido,
      [pedidoId]: prevCount + 1,
    };
    set({
      mensajesNoLeidosPorPedido: newData,
      totalNoLeidos: state.totalNoLeidos + 1,
    });
  },

  limpiarNoLeidos: (pedidoId: string) => {
    const state = get();
    const prevCount = state.mensajesNoLeidosPorPedido[pedidoId] || 0;
    if (prevCount === 0) return;

    const newData = { ...state.mensajesNoLeidosPorPedido };
    delete newData[pedidoId];

    set({
      mensajesNoLeidosPorPedido: newData,
      totalNoLeidos: Math.max(0, state.totalNoLeidos - prevCount),
    });
  },

  reset: () => {
    set({ totalNoLeidos: 0, mensajesNoLeidosPorPedido: {} });
  },
}));
